/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 * @author Julia Ignatieva
 * @version 1.36.0
 * @since 1.36.0
 */

import { ReactElement } from 'react';

import { Typography } from '@nexign/scc-ui-kit';
import isFunction from 'lodash/isFunction';

import { LinkBlock } from '@components/common';
import { IUserNotificationTranslation } from '@modules/internationalization/types';
import { openExternalRoute } from '@routes/constants/externalRoutes';

import { INotificationsEntity } from '../types';
import { getNotificationContent } from './commonNotificationsUtils';

export const getCashbackNotificationData = (
    id: string | number,
    entity: INotificationsEntity,
    translation: IUserNotificationTranslation,
    handleExternalNotification: (id: string | number) => void,
    onLinkClick?: () => void,
): [ReactElement, ReactElement | undefined] => {
    const entityDef = getNotificationContent(entity);
    const content = <Typography isDangerousInnerHTML>{entityDef}</Typography>;

    const linkHref = entity.link ?? ''

    const handleLinkClick = () => {
        if (linkHref && id) {
            handleExternalNotification(id);
            openExternalRoute(linkHref, '_blank');
        }
        if (isFunction(onLinkClick)) onLinkClick();
    };

    const ItemLink =
        !!linkHref
            ? (
                <div>
                    <LinkBlock
                        isExternalUrl
                        withArrow
                        target={'_blank'}
                        url={linkHref}
                        onClick={handleLinkClick}
                    >
                        {translation.linkText.cashback}
                    </LinkBlock>
                </div>
            )
            : undefined;

    return [content, ItemLink];
};
